<template>
    <div class="flex flex-col items-center justify-center gap-2 py-10 text-center">
        <div class="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
            <component :is="icon" class="h-6 w-6 text-gray-400 dark:text-gray-500" />
        </div>
        <p class="text-sm font-medium text-gray-600 dark:text-gray-300">
            {{ title }}
        </p>
        <p v-if="hint" class="max-w-xs text-xs text-gray-400 dark:text-gray-500">
            {{ hint }}
        </p>
    </div>
</template>

<script>
// Variante compacta do EmptyState.vue (que é pensado para páginas/tabelas
// inteiras, com imagem grande) — para uso dentro de cards e painéis menores.
export default {
    name: 'InlineEmptyState',
    props: {
        icon: {
            type: [Object, Function, String],
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        hint: {
            type: String,
            default: null,
        },
    },
};
</script>
